import { checkUserAuthorized } from '../utils/authorization';
import { OfficialData } from '../networkRequest/officialsService';

interface ProtectedElementProps {
  allowedRoles: string[];
  userProfile: OfficialData;
  children: React.ReactNode;
}

const ProtectedElement = ({ userProfile, allowedRoles, children }: ProtectedElementProps) => {
  const userAuthorized = checkUserAuthorized(userProfile, allowedRoles);
  return <>{userAuthorized ? children : null}</>;
};

export default ProtectedElement;
